import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Chart Bar Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M243.79 219.668h-9.649V26.683c0-5.329-4.32-9.65-9.649-9.65h-67.544c-5.33 0-9.65 4.321-9.65 9.65V74.93H89.403c-5.33 0-9.65 4.32-9.65 9.65v48.246H31.509c-5.33 0-9.65 4.32-9.65 9.649v77.194H12.21c-7.428 0-12.07 8.041-8.356 14.474a9.65 9.65 0 0 0 8.356 4.824h231.582c7.428 0 12.07-8.041 8.356-14.474a9.65 9.65 0 0 0-8.356-4.824M166.598 36.332h48.246v183.336h-48.246ZM99.052 94.228H147.3v125.44H99.051Zm-57.895 57.895h38.597v67.545H41.157Z" }, null, -1)
  ])))
}
export default { render: render }